import { CheckCircle } from 'assets/icons/CheckCircle';
import { APARTMENT_ADAPTER } from 'consts';
import { useTranslation } from 'react-i18next';

export const BuildingHoverCard = ({ event }) => {
  const { t } = useTranslation();

  const { target } = event;
  const { left, top, width, height } = target.getBoundingClientRect();
  const { wallArea = 70, usageArea = 56.1, type = 'studio' } = target.dataset;

  const isNearBottom = top + height > window.innerHeight - 300;
  const isNearRight = left + width > window.innerWidth - 300;

  const cardStyle = {
    left: isNearRight ? 'auto' : left + width + 8,
    right: isNearRight ? 36 : 'auto',
    top: isNearBottom ? 'auto' : top,
    bottom: isNearBottom ? 36 : 'auto',
  };

  console.log(APARTMENT_ADAPTER?.[type], type);

  return (
    <div className="building-hover-card" style={cardStyle}>
      <div className="image">
        <img
          src={APARTMENT_ADAPTER?.[type]?.mini}
          alt={`Layout ${APARTMENT_ADAPTER?.[type]?.label || 'Căn hộ Studio'}`}
        />
      </div>
      <div className="tooltip-body">
        <p className="title">
          {t(APARTMENT_ADAPTER?.[type]?.label) || t('studio_long')}
        </p>
        <ul className="list">
          <li className="list-item">
            <CheckCircle />
            <span className="text">WC</span>
            <span>{APARTMENT_ADAPTER?.[type]?.wc || 0}</span>
          </li>
          <li className="list-item">
            <CheckCircle />
            <span className="text">{t('net_floor_area')}</span>
            <span>{usageArea}m2</span>
          </li>
          <li className="list-item">
            <CheckCircle />
            <span className="text">{t('built_up_area')}</span>
            <span>{wallArea}m2</span>
          </li>
        </ul>
      </div>
      <button className="more-btn">{t('learn_more')}</button>
    </div>
  );
};
